import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>© {new Date().getFullYear()} Latent Lab Academy</p>
    </footer>
  );
};

export default Footer;
